// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1117t","rightAdornment":"Header_rightAdornment__375Kp"};